import { Service, signal } from '@angular/core';
import { SelectItem } from '@modals';
import { CompanySelectionRequest } from './company-selection-request.model';

@Service()
export class CompanySelectionService {
  readonly activeRequest = signal<CompanySelectionRequest | null>(null);

  private resolveSelection?: (selection: SelectItem | null) => void;

  select(request: CompanySelectionRequest): Promise<SelectItem | null> {
    this.resolveSelection?.(null);

    this.activeRequest.set(request);
    return new Promise<SelectItem | null>((resolve) => {
      this.resolveSelection = resolve;
    });
  }

  complete(selection: SelectItem | null): void {
    this.activeRequest.set(null);
    const resolve = this.resolveSelection;
    this.resolveSelection = undefined;
    resolve?.(selection);
  }
}
